import { render, staticRenderFns } from "./FailedSyncs.vue?vue&type=template&id=10c7469a&scoped=true&"
import script from "./FailedSyncs.vue?vue&type=script&lang=js&"
export * from "./FailedSyncs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7469a",
  null
  
)

export default component.exports